import { KrCard } from '@/common/card/KrCard';
import { FilterContainer } from '@/common/dashboard/FilterContainer';
import { Form } from '@/common/form/Form';
import { FormFields } from '@/common/form/rendering/FormFields';
import { useNavStateSync } from '@/common/hooks/navState/useNavStateSync';
import { ContentBox } from '@/common/layout/ContentBox';
import { Spacer, SpacerLayout } from '@/common/layout/SpacerLayout';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Title } from '@/common/title/Title';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { McoPhsCapCards } from './McoPhsCapCards';
import { McoPhsCapChart } from './McoPhsCapChart';
import { McoPhsCapPieChart } from './McoPhsCapPieChart';
import { McoPhsCapTable } from './McoPhsCapTable';

export const McoPhsCapDashboard = () => {
  const rsrc = useRsrc();

  const { navState } = useNavState();

  const [fieldDefs, setFieldDefs] = useState();
  const [formValues, setFormValues] = useNavStateSync('formValues');

  useEffect(() => {
    rsrc.data('sc', 'MCO_PHS_CAP_DASHBOARD_FILTERS_DATA_PLUGIN', {}).then((res) => {
      setFieldDefs([
        { field: 'mcoInvId', displayName: 'Managed Care Invoice', type: 'DROPDOWN', values: res.mcoInvs },
        { field: 'prodIds', displayName: 'Products', type: 'TREE', treeData: res.prodTreeData },
        { field: 'periodIds', displayName: 'Fill Months', type: 'TREE', treeData: res.periodTreeData },
      ]);

      if (!navState.formValues) {
        setFormValues({
          mcoInvId: res.mcoInvs[0].value,
          prodIds: res.prodIds,
          periodIds: res.periodIds,
        });
      }
    });
  }, []);

  if (!fieldDefs) {
    return;
  }

  return (
    <ContentBox>
      <Box
        sx={{
          mb: 1,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
        }}
      >
        <Title icon={fas.faTasks} title="Managed Care 340B Cap Dashboard" />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}></Box>
      </Box>

      {/* Filters */}
      <Form formValues={formValues} setFormValues={setFormValues}>
        <FormFields fieldDefs={fieldDefs} container={FilterContainer} />
      </Form>

      <SpacerLayout>
        <Spacer vertical>
          <Spacer weights={[1, 1]}>
            <KrCard title="Overflow Percentage" sx={{ flex: 1 }}>
              <McoPhsCapPieChart formValues={formValues} />
            </KrCard>
            <KrCard title="Managed Care 340B Cap" sx={{ flex: 1 }}>
              <McoPhsCapTable formValues={formValues} />
            </KrCard>
          </Spacer>
          <Spacer weights={[1, 4]}>
            <McoPhsCapCards formValues={formValues} />
            <KrCard title="Managed Care 340B Cap" sx={{ flex: 1 }}>
              <McoPhsCapChart formValues={formValues} />
            </KrCard>
          </Spacer>
        </Spacer>
      </SpacerLayout>
    </ContentBox>
  );
};
